import React, { ReactElement, useCallback } from 'react'
import { type RadioButtonProps } from './RadioButton'

interface RadioButtonGroupProps<T> {
  children?: ReactElement<RadioButtonProps<T>>[];
  value: T;
  onChange?: (value: T) => void;
}


const RadioButtonGroup: <T>(p: RadioButtonGroupProps<T>) => ReactElement | null = ({ children, value, onChange }) => {
  if (!children || children.length === 0) return null

  return (
    <div className="radio-group horizontal">
      {children?.map((child, index) =>
        (<RadioButtonGroupChild<typeof value> key={index} {...child.props} isSelected={child.props.value === value} onSelect={() => onChange && onChange(child.props.value)} />)
      )}
    </div>
  )
}

export interface RadioButtonGroupChildProps<T> {
  label: string;
  value: T;
  isSelected: boolean;
  onSelect: () => void;
}

const RadioButtonGroupChild: <T>(p: RadioButtonGroupChildProps<T>) => ReactElement = ({ label, isSelected, onSelect }) => {
  const classes = `input-option${isSelected ? " selected" : ""}`

  const onClick = useCallback((e: React.MouseEvent<HTMLSpanElement>) => onSelect(), [onSelect])

  return (
    <span className={classes} onClick={onClick}>{label}</span>
  )
}

export default RadioButtonGroup